import React, {useContext} from 'react'
import {useStaticQuery, graphql} from "gatsby"
import Img from "gatsby-image"
import {GlobalStateContext} from "../../../context/GlobalContextProvider"

const THNews202307 = (state) => {
    state = useContext(GlobalStateContext);

    const data = useStaticQuery(graphql`
        query {
            press202307THNewsImage: file(relativePath: { eq: "Publications/Press/forum23Nachlese.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 250, quality: 90) {
                        ...GatsbyImageSharpFluid_withWebp
                    }
                }
            } 
        }
    `)

    return (
        <div className={state.pressId}>
            <div className="box">
                <div className="image-container">
                    <p className="subtitle" >
                    <a href="https://www.th-wildau.de/hochschule/aktuelles/neuigkeiten/news/informationssicherheit-2-awareness-forum-bot-praktische-einstiegsmoeglichkeiten-echtzeit-hacking-u/" target="_blank" rel="noreferrer">
                        <Img fluid={data.press202307THNewsImage.childImageSharp.fluid} 
                        className="image"/> 
                    </a>
                    </p>
                </div>
                <p>Abschlußveranstaltung</p>
               
                <p className="subtitle">
                    Nachbetrachtungen 
                    </p>
            </div>
        </div>
    )
};

export default THNews202307;